const stringSentiment = (sentiment: string) => {
  switch (sentiment) {
    case "긍정":
    case "positive":
      return "positive-2";
    case "부정":
    case "negative":
      return "negative-2";
    case "중립":
    case "neutral":
      return "neutral";
    default:
      return "default";
  }
};

const objectSentiment = (sentiment: {
  positive: number;
  negative: number;
  neutral: number;
}) => {
  const { positive, negative, neutral } = sentiment;

  if (positive + negative + neutral === 0) return "default";
  if (positive + negative < neutral) return "neutral";
  if (positive > negative * 3) return "positive-1";
  if (positive > negative * 2) return "positive-2";
  if (positive > negative) return "positive-3";
  if (negative > positive * 3) return "negative-1";
  if (negative > positive * 2) return "negative-2";
  if (negative > positive) return "negative-3";

  return "neutral";
};

export const sentimentCalc = (
  sentiment?: string | { positive: number; negative: number; neutral: number }
) => {
  if (typeof sentiment === "string") {
    return stringSentiment(sentiment);
  } else if (typeof sentiment === "object") {
    return objectSentiment(sentiment);
  }
};
